module.exports = ".seller-proceeds-table .form-group {\n    margin: 0;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/agora/components/account-data/accounts/edit/update-seller-account/update-seller-account.component.css
// module id = ./src/app/agora/components/account-data/accounts/edit/update-seller-account/update-seller-account.component.css
// module chunks = main